///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { selectQueryParams, selectRouteData } from '../router-store/router.selector';
import { selectCurrentCustomer } from '../shared/store/customerAccordionStore/accordion.selectors';
import { Observable } from 'rxjs';
import { Params } from '@angular/router';

@Component({
    selector: 'winde-customers-panel',
    templateUrl: './customers.component.html',
    styleUrls: ['customers.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GtthCustomerComponent {
    baseUrl$ = this.store.select(selectRouteData).pipe(map((routeData) => routeData.tabName));
    selectedCustomer$ = this.store.select(selectCurrentCustomer);
    customerFilter$: Observable<string> = this.store.select(selectQueryParams).pipe(map((queryParams: Params) => queryParams.filter));
    customersBadgeAttribute = 'numberOfUsers';

    constructor(private readonly store: Store) {}
}
